import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=eb4c95b8&scoped=true&"
import script from "./Events.js?vue&type=script&lang=js&"
export * from "./Events.js?vue&type=script&lang=js&"
import style0 from "./Events.scss?vue&type=style&index=0&id=eb4c95b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4c95b8",
  null
  
)

export default component.exports